import { Promotion } from './wallet';

export interface Reward {
  id: string,
  startDate: Date,
  promotionCode?: string,
  endDate: Date,
  title: string,
  description: string,
  terms: string,
  mediaUri: string,
  isFavorite: boolean,
  offerType: string,
  tag: string,
  products: string,
  points: number,
  channel: string,
  donationAmount: string,
  foundationName: string,
  sortOrder: number
}

export interface Campaign {
  title: string,
  endDate?: Date,
  description: string,
  terms: string,
  mediaUri: string,
  medallionText: string,
  ctaType: string,
  isMultiStepCampaign: boolean,
  multiStepDescription: string,
  totalNumberOfSteps: number,
  currentStep: number,
  sortOrder: number,
  extraPoints: number,
  campaignType: string
}

export interface Achievement {
  achievementId: string,
  title: string,
  description: string,
  tagLine: string,
  achievementDate: Date,
  mediaUri: string,
  medallionText: string,
  pointsEarned: number,
  shareText: string,
  badgeType: 'milestone' | 'extra';
}

export interface RewardOfferType {
  offerType: OfferTypeFilter,
  title: string,
  description: string,
  mediaUri: string,
  sortOrder: number
}

export interface RedeemDisplayInfo{
  description: string,
  mediaUri: string,
  terms: string,
  title: string
}

export interface PurchasedReward{
  id: string,
  offerType: OfferTypeFilter,
  pointsRemaining: number,
  pointsSpent: number,
  redeemDisplayInfo: RedeemDisplayInfo,
  promotionCode: string
}

export type RewardWithPromoContext = { promotion?: Promotion; purchasedReward?: PurchasedReward, reward: Reward; showErrorMessage?: boolean; redeemDisplayInfo?: RedeemDisplayInfo, promotionCode?: string;};

export interface GetRewardOffersResponse {
  rewardStoreOffers: Reward[];
}

export interface GetExtrasCampaignsResponse {
  campaigns: Campaign[];
}

export interface GetExtrasAchievementsResponse {
  achievementYears: AchievementYear[];
  totalPointsEarnedFromExtras: number;
}

export interface AchievementYear {
  badgeYear: number;
  badges: Badge[];
}

export interface Badge {
  earnedCount: number;
  achievement: Achievement;
}

export interface GetRewardOfferTypesResponse {
  rewardStoreOfferTypes: RewardOfferType[];
}

export enum OfferTypeFilter {
  Food = 'Food',
  Goods = 'Goods',
  Giving = 'Giving',
}

export enum RewardStoreErrorCode {
  RewardStoreUnavailable = 'RS-1002',
  CustomerRecordUnavailable = 'RS-1003',
  CustomerNotEnrolledInLoyalty = 'RS-1004',
  SessionMCustomerNotFound = 'RS-1005',
  InsufficientPoints = 'RS-1006',
  SparkflyUnavailable = 'RS-1007',
  SparkflyOfferNotFound = 'RS-1008'
}

export enum AchievementTitle {
  TheDoubleUp = 'the double up',
  BigSipper = 'big sipper',
  Threepeat = 'three-peat',
  InTheBag = 'in the bag',
  LunchLegend = 'lunch legend',
  NationalGuacDay = 'national guac day',
  FirstToTryBrisket = 'first to try brisket'
}

export interface BagOffersResponse{
  rewardStoreOffers: Reward[];
}

export enum CampaignTypes {
  Extra = 'extra',
  Milestone = 'milestone'
}